var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 230,
    viewBox: "0 0 215 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cdyj1mie8a",
    d: "M0 230h215V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1612B",
    d: "M3.564 227.051h59.392V7.371H3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1612B",
    d: "M52.265 227.051h131.851v-22.115H52.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1612B",
    d: "M171.05 227.051h40.386V8.846H171.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1612B",
    d: "M3.564 210.833h207.872V4.423H3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7141",
    d: "M62.956 204.936H165.11V25.064H62.956z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.195 31.48c-1.191-1.67-3.73-.787-4.467.954-1.53 3.611-.676 11.208 0 13.361",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.835 43.645c-5.658 3.015-10.423 5.566-12.508 8.117-4.951 6.059-4.593 20.142-5.062 27.361-.973 15.016-2.084 42.897-2.084 57.739 0 .927 26.205-3.942 33.733-5.565.36.464.226-55.39.226-78.608 0-3.247-9.838-9.044-10.136-9.044-2.085 0-4.027-.298-4.169.232",
    fill: "#FEF398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.835 43.645c-5.658 3.015-10.423 5.566-12.508 8.117-4.951 6.059-4.593 20.142-5.062 27.361-.973 15.016-2.084 42.897-2.084 57.739 0 .927 26.205-3.942 33.733-5.565.36.464.226-55.39.226-78.608 0-3.247-9.838-9.044-10.136-9.044-2.085 0-4.027-.298-4.169.232M72.38 25.011v169.281M158.523 193.815h-85.76M72.665 194.053l-8.153 10.489",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.005 165.82c-.034-1.564-.302-15.444-.35-18.137-.419-23.345-1.331-84.598-2.131-105.134-7.743 2.147-16.32 3.956-21.738 5.726.893 18.61.893 84.222 1.819 100.182-.01.167.127 1.29.117 1.457",
    fill: "#C8AF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.005 165.82c-.034-1.564-.302-15.444-.35-18.137-.419-23.345-1.331-84.598-2.131-105.134-7.743 2.147-16.32 3.956-21.738 5.726.893 18.61.893 84.222 1.819 100.182-.01.167.127 1.29.117 1.457",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "kq83ipo86b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cdyj1mie8a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M58.47 209.561h112.56V20.6H58.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.604 24.416c3.618-1.843 8.866-2.015 13.102-2.227 5.927-.296 7.433.134 8.338 5.568 1.278 7.67.946 16.195 0 23.858-.931 7.547-2.188 15.003-1.191 22.905.99 7.85 2.21 16.41 1.787 24.31-.856 16 0 32.042 0 48.221 0 7.967-.117 16.049-.627 23.859-.505 7.74 1.997 15.075 2.382 22.905.201 4.101-1.043 11.733-6.357 14.339-8.066 3.958-14.95-6.648-17.284-11.57-5.898-12.427-4.219-27.112-5.51-40.097-.702-7.072-.177-14.14-.564-21.246-.248-4.539-2.735-11.195 1.755-14.912",
    fill: "#F1612B",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M63.83 204.79h101.84V24.893H63.83zM63.831 204.551l-37.52 21.712M64.19 24.984 26.099 7.265M25.716 7.238v218.411M18.977 226.263h6.8V7.238h-6.8zM171.625 20.581h41.689M171.186 209.489h42.921M170.983 21.076V.716M58.471 21.049V1.714M171.03 210.039v19.245M58.471 210.066v18.519M18.76 20.599H.893M18.76 210.039H.893M53.785.954v19.087M48.796 1.652v16.107M53.92 210.988v18.296"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kq83ipo86b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.226 174.489c.036-3.793-1.239-10.981-2.312-14.548-1.03-3.424-2.338-9.97-3.719-13.128-1.71-3.91-7.716-.659-11.801 1.61-3.713 2.065-2.865 7.358-3.07 10.796-.478 8.022-2.026 16.268-1.443 24.336.29 4.017 3.791 18.639 10.591 18.61 1.635-.007 8.146-5.249 10.86-9.066",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.226 174.489c.036-3.793-1.239-10.981-2.312-14.548-1.03-3.424-2.338-9.97-3.719-13.128-1.71-3.91-7.716-.659-11.801 1.61-3.713 2.065-2.865 7.358-3.07 10.796-.478 8.022-2.026 16.268-1.443 24.336.29 4.017 3.791 18.639 10.591 18.61 1.635-.007 8.146-5.249 10.86-9.066",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M49.426 212.822v15.746M158.5 25.011v169.281M157.928 193.337l7.595 11.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6063",
    mask: "url(#kq83ipo86b)",
    d: "M68.594 36.505h93.502V32.33H68.594z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M68.594 36.505h93.502V32.33H68.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.488 31.48c-1.191-1.67-3.73-.787-4.467.954-1.53 3.611-.676 11.208 0 13.361",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kq83ipo86b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.128 43.645c-5.658 3.015-10.422 5.566-12.506 8.117-4.953 6.059-4.594 20.142-5.063 27.361-.974 15.016-2.084 42.897-2.084 57.739 0 .927 26.204-3.942 33.732-5.565.36.464.226-55.39.226-78.608 0-3.247-9.838-9.044-10.136-9.044-2.084 0-4.027-.298-4.169.232",
    fill: "#FEF398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.128 43.645c-5.658 3.015-10.422 5.566-12.506 8.117-4.953 6.059-4.594 20.142-5.063 27.361-.974 15.016-2.084 42.897-2.084 57.739 0 .927 26.204-3.942 33.732-5.565.36.464.226-55.39.226-78.608 0-3.247-9.838-9.044-10.136-9.044-2.084 0-4.027-.298-4.169.232",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.675 31.574c-1.192-1.67-3.73-.786-4.467.954-1.53 3.612-.677 11.208 0 13.361",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kq83ipo86b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.315 43.737c-5.658 3.014-10.422 5.565-12.507 8.116-4.952 6.06-4.594 20.144-5.062 27.363-.974 15.015-2.084 42.895-2.084 57.738 0 .927 26.204-3.942 33.731-5.566.361.464.227-55.39.227-78.607 0-3.247-9.839-9.044-10.137-9.044-2.084 0-4.027-.297-4.168.231",
    fill: "#FEF398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.315 43.737c-5.658 3.014-10.422 5.565-12.507 8.116-4.952 6.06-4.594 20.144-5.062 27.363-.974 15.015-2.084 42.895-2.084 57.738 0 .927 26.204-3.942 33.731-5.566.361.464.227-55.39.227-78.607 0-3.247-9.839-9.044-10.137-9.044-2.084 0-4.027-.297-4.168.231",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.91 56.626c.596 8.589 0 55.401 0 64.896",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F69536",
    mask: "url(#kq83ipo86b)",
    d: "M158.716 166.934H93.454l-2.859 9.496h70.186z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M158.716 166.934H93.454l-2.859 9.496h70.186z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kq83ipo86b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.044 155.82c-.956-1.657-2.382-6.168-4.467-12.555-.183-.564-16.379-.27-23.823-.217-3.276 5.434-6.09 8.657-7.974 13.063-2.055 4.807-1.881 11.6-1.555 16.888 3.574.238 28.885-.239 36.925 0",
    fill: "#93C4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.044 155.82c-.956-1.657-2.382-6.168-4.467-12.555-.183-.564-16.379-.27-23.823-.217-3.276 5.434-6.09 8.657-7.974 13.063-2.055 4.807-1.881 11.6-1.555 16.888 3.574.238 28.885-.239 36.925 0",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.121 143.503c-1.628 5.433-3.415 7.103-4.904 12.83-.914 3.517-1.488 10.462-1.488 16.427",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8AF66",
    mask: "url(#kq83ipo86b)",
    d: "M128.637 173.034h31.06v-19.049h-31.06z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M128.637 173.034h31.06v-19.049h-31.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8AF66",
    mask: "url(#kq83ipo86b)",
    d: "M158.732 145.319h-28.846l-1.263 8.689h31.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M158.732 145.319h-28.846l-1.263 8.689h31.02zM144.528 145.358v26.96M158.821 149.175h-28.288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.421 148.937c2.71-1.557 5.577-6.199 5.613-8.792-3.677-.568-5.435 6.892-6.506 8.349-.002-1.46.912-11.401-2.612-9.53-2.894 1.535 1.062 9.186 2.91 10.45",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.124 148.937c5.338 1.835 7.146 5.249 8.337 9.066M144.23 148.937c-4.418 1.303-7.397 5.88-8.635 9.305M117.728 172.795c.396-1.524 3.264-2.676 4.17-4.056 2.097.687 4.497 3.562 6.55 3.102M122.195 168.978v-20.041",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.599 164.683c0 2.899-2.934 5.25-6.552 5.25h-4.467c-3.617 0-6.55-2.351-6.55-5.25 0-2.898 2.933-5.249 6.55-5.249h4.467c3.618 0 6.552 2.351 6.552 5.25",
    fill: "#F1612B",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.599 164.683c0 2.899-2.934 5.25-6.552 5.25h-4.467c-3.617 0-6.55-2.351-6.55-5.25 0-2.898 2.933-5.249 6.55-5.249h4.467c3.618 0 6.552 2.351 6.552 5.25z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F69536",
    mask: "url(#kq83ipo86b)",
    d: "M90.627 202.165h70.278v-25.767H90.627z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M90.627 202.165h70.278v-25.767H90.627z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF398",
    mask: "url(#kq83ipo86b)",
    d: "M138.573 198.586h16.996v-9.782h-16.996z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)",
    d: "M138.573 198.586h16.996v-9.782h-16.996zM134.701 198.109l-10.422-.238M134.106 194.292h-8.636M134.701 190.236h-8.039M81.101 149.914c0 5.25-.892 19.749-1.496 24.098-1.1 7.934 1.044 15.779.887 23.642"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kq83ipo86b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.25 125.936c-.002 4.15.453 8.237.15 12.407-1.787.238-3.14.357-4.616.357-.252-3.98.149-7.555-.298-12.764 1.43-.277 2.531-.12 4.615-.239",
    fill: "#93C4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 125.936c-.002 4.15.453 8.237.15 12.407-1.787.238-3.14.357-4.616.357-.252-3.98.149-7.555-.298-12.764 1.43-.277 2.531-.12 4.615-.239",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.461 116.193c0 2.987-1.955 5.408-4.367 5.408s-4.367-2.42-4.367-5.408c0-2.986 1.955-5.407 4.367-5.407s4.367 2.42 4.367 5.407",
    fill: "#F69536",
    mask: "url(#kq83ipo86b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.461 116.193c0 2.987-1.955 5.408-4.367 5.408s-4.367-2.42-4.367-5.408c0-2.986 1.955-5.407 4.367-5.407s4.367 2.42 4.367 5.407z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#kq83ipo86b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentLocker);
export default __webpack_public_path__ + "static/media/rent_locker.fd29af244f95d29515473342ab6d9abe.svg";
export { ForwardRef as ReactComponent };